<template>
  <div
    :class="['base-dropdown', isOpen ? 'open' : 'closed']"
    tabindex="-1"
    @click="toggleOpen()"
    @blur="close()"
  >
    <input
      v-if="isSearch"
      v-model="currentValue"
      class="dropdown-button"
      :placeholder="currentLabel"
      @input="filterBearings"
    />
    <span 
      v-else 
      class="dropdown-button">{{ currentLabel }}</span>
    <ul :class="'dropdown-content'">
      <li
        v-for="(option, id) in filteredOptions"
        :key="id"
        @click="( (isSimpleDropdown && option.selectable === undefined) || option.isSelectable) ? selectOption(id) : ''"
        :class="[( (isSimpleDropdown && option.selectable === undefined) || option.isSelectable) ? 'selectable' : 'disabled']"
      >
        {{ isSimpleDropdown?option:option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BaseDropdown",
  props: {
    options: {
      type: Object,
      default: function () {
        return {
          0: {
            value: 0,
            label: " -- Bitte auswählen -- ",
            selectedLabel: " --- ",
            isSelectable: false,
          },
        };
      },
    },
    defaultOptionID: {
      type: Number,
      default: -1,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    isSimpleDropdown: {
      type: Boolean,
      default:false
    },
    simpleDropdownLabel: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      isOpen: false,
      currentOption: this.defaultOptionID,
      currentLabel: this.isSimpleDropdown?(this.defaultOptionID>-1?this.options[this.defaultOptionID]:this.simpleDropdownLabel):this.options[this.defaultOptionID].selectedLabel,
      currentValue: '',
      filteredOptions: this.options,
    };
  },
  methods: {
    selectOption(id) {
      this.currentOption = id;
      this.currentLabel = this.isSimpleDropdown?this.filteredOptions[id]:this.filteredOptions[id].selectedLabel;
      this.currentValue = this.isSimpleDropdown?this.filteredOptions[id]:this.filteredOptions[id].value;
      this.$emit("update:value", this.currentValue);
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
    filterBearings(e) {
      if (e.target.value != "") {
        if(this.isSimpleDropdown){
          this.filteredOptions = this.options.filter(
            (option) =>
              String(option).startsWith( e.target.value.replace(",", ".") )
          );
        } else {
          this.filteredOptions = this.options.filter(
          (option) =>
            String(option.value).startsWith( e.target.value.replace(",", ".") )
          );
        }

      } else {
        this.filteredOptions = this.options;
      }
      if (this.filteredOptions.length === 0) {
        this.filteredOptions = [
          {
            value: 0,
            label: "Kein Treffer gefunden",
            selectedLabel: "",
            isSelectable: false,
          },
        ];
      }

      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss">
.base-dropdown {
  color: $blueDark;
  background: white;
  border: 1px solid #707070;

  width: 25rem;
  border-radius: $defaultBorderRadius;
  display: flex;
  align-items: baseline;
  position: relative;

  padding-right: 1rem;

  max-width: 100%;

  cursor: pointer;

  &:focus {
    outline: 0;
  }

  &:after {
    content: "\25BC";

    transition: 0.5s all;
  }

  input {
    border: 0;
    &:focus {
      outline: 0;
    }
  }

  .dropdown-button {
    width: 100%;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    font-size: 1.25rem;
  }
  .dropdown-content {
    position: absolute;
    top: calc(100% - 0.5rem);
    left: -1px;
    right: 0;
    margin: 0;
    margin-right: -1px;
    padding: 0;
    padding-top: 0.5rem;
    list-style: none;
    border: 1px solid #707070;
    border-top: 0;
    border-radius: 0 0 $defaultBorderRadius $defaultBorderRadius;
    box-sizing: border-box;
    background: white;

    max-height: 0;

    transition: 0.5s all;

    li {
      padding: 0.5rem 1rem;
      &:hover {
        //background-color: #93c7de;
        background-color: $blueDark;
        color: white;
        font-weight: bold;
      }
      &.disabled {
        color: $blueLighter;
        &:hover {
          background-color: white;
          color: $blueLighter;
        }
      }
    }
  }

  &.open {
    z-index: 20;
    .dropdown-content {
      max-height: 50rem;
      padding-bottom: 1rem;
      overflow:auto;

      &:after {
        transform: rotate(-180deg);
      }
    }
  }

  &.closed ul.dropdown-content li {
    visibility: hidden;
  }
}
</style>
